
import React, { Component } from 'react';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import Chip from '@material-ui/core/Chip';
import { grey } from '@material-ui/core/colors';

import TableListSort from 'core/TableListSort';


export default class ChoiceListTable extends Component {
  render() {
    const { items, onDetail } = this.props;
    return (
      <React.Fragment>
        <TableHead>
          <TableRow>
            <TableCell component="th" scope="row" className={'hide-on-mobile'}>
              <TableListSort label={'#'} name={'id'} />
            </TableCell>
            <TableCell component="th" scope="row">
              <TableListSort label={'Название'} name={'name'} />
            </TableCell>
            <TableCell component="th" scope="row">
              Тип
            </TableCell>
            <TableCell component="th" scope="row">
              Описание
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
        {items.map(item =>
          <TableRow
            key={item.id}
            hover={true}
            className={'pointer'}
            onClick={(event) => onDetail(item)}
            style={{
              backgroundColor: item.is_active ? 'inherit' : grey[200]
            }}
          >
            <TableCell className={'hide-on-mobile'}>{item.id}</TableCell>
            <TableCell>
              {item.label}
              {!item.is_active && <Chip label={'Неактивно'} className={'ml-10'} size={'small'} />}
            </TableCell>
            <TableCell>{item.type_display}</TableCell>
            <TableCell>{item.description}</TableCell>
          </TableRow>
        )}
        </TableBody>
      </React.Fragment>
    )
  }
}
